import React, { useEffect, useState } from "react";
import { Calendar, Badge, Modal, Avatar } from "antd";
import { Table, CardWithLable, Spinner, Button } from "@public/ui-toolkit";
import moment from "moment";
import { UserOutlined } from "@ant-design/icons";

const CalendarPage = (meetingDatas) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [modalMeetingData, setModalMeetingData] = useState(null);
  const [meetingData, setMeetingData] = useState([]);
  useEffect(() => {
    setMeetingData(meetingDatas.meetingData);
  }, [meetingDatas.meetingData]);

  const showMeetingDetails = (date) => {
    const dateStr = date.format("YYYY-MM-DD");
    //Get the date of meeting from start date
    const meetingsForDate = meetingData.filter((meeting) => {
      const startTime = moment(meeting.startTime).format("YYYY-MM-DD");
      return startTime === dateStr;
    });

    if (meetingsForDate.length > 0) {
      setModalMeetingData(meetingsForDate);
      setModalVisible(true);
    }
  };

  const closeModal = () => {
    setModalVisible(false);
  };

  const cellRender = (current) => {
    const date = current.format("YYYY-MM-DD");
    const meetings = meetingData.filter((meeting) => {
      const startTime = moment(meeting.startTime).format("YYYY-MM-DD");
      return startTime === date;
    });
    return (
      <div
        onClick={() => showMeetingDetails(current)}
        style={{
          borderBottom: meetings.length > 0 ? "2px solid #1890ff" : "none",
        }}
      >
        {meetings.length > 0 && (
          <div>
            {meetings.map((meeting, index) => (
              <Badge status="success" text={`${meeting.topic}`} />
            ))}
          </div>
        )}
      </div>
    );
  };

  return (
    <div>
      <main>
        <div className="main-inner mt-2 ">
          <div className="container mt-2">
            <div>
              <h2 className="text-center">All Meetings</h2>
            </div>
            <CardWithLable title={"Monthly Meetings"}>
              <div className="hf-card2-body px-0 pb-0">
                <div className="hf-table">
                  <Calendar cellRender={cellRender} />
                </div>
              </div>
            </CardWithLable>
          </div>
        </div>
      </main>
      <Modal
        open={modalVisible}
        onOk={closeModal}
        onCancel={closeModal}
        closable={false}
        cancelText={"Close"}
      >
        {modalMeetingData && (
          <div>
            {modalMeetingData.map((meeting, index) => (
              <div key={index}>
                <div className="bullet-heading">
                  <span class="bullet">&#x2022;</span>
                  <h1>{meeting.topic}</h1>
                </div>
                <p className="meeting-time">
                  {moment(meeting.startTime).format(
                    "dddd, MMMM D, YYYY, h:mm A"
                  )}{" "}
                  - {moment(meeting.endTime).format("h:mm A")}
                </p>
                <a
                  className="meeting-url"
                  href={meeting.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {meeting.url}
                </a>{" "}
                {meeting.appointmentAttendees && (
                  <div className="meeting-attendees">
                    <h4>Attendees:</h4>
                    <ul>
                      {meeting.appointmentAttendees.map((attendee, i) => (
                        <li key={i}>
                          {" "}
                          <div
                            style={{
                              display: "flex",
                              gap: "10px",
                            }}
                          >
                            <Avatar
                              size="large"
                              src={meeting.profileImage}
                              icon={<UserOutlined />}
                            />
                            {attendee.userFullName}
                            <br />
                            {attendee.userEmailAddress}{" "}
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
                <p className="meeting-description">{meeting.description}</p>
              </div>
            ))}
          </div>
        )}
      </Modal>
    </div>
  );
};

export default CalendarPage;
